// LoginPage.js
import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import './LoginPage.css';

const AVAILABLE_POSITIONS = [
  "Charging",
  "Cleaning and Polishing",
  "Grading and Quality Control",
  "Packaging",
  "Quality Control",
  "Dismount",
 
  "Assemblage DS5",
  "Repair"
];

const LoginPage = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [position, setPosition] = useState('Select Position');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const loadRoles = async () => {
      try {
        console.log(' Début du chargement des rôles...');
        const rolesData = await api.getAllDs5Role();
        console.log('Rôles chargés avec succès:', rolesData);
        
        if (!Array.isArray(rolesData)) {
          console.error('Format de données invalide pour les rôles:', rolesData);
          return;
        }
        
        setRoles(rolesData);
        console.log(`${rolesData.length} rôles disponibles:`, rolesData.map(r => `${r.id}:${r.role}`).join(', '));
        
      } catch (err) {
        console.error('Erreur lors du chargement des rôles:', err);
        console.error('Détails de l\'erreur:', {
          message: err.message,
          stack: err.stack
        });
      }
    };

    loadRoles();
  }, []);

  const getRoleNameById = (idRole) => {
    console.log(`Recherche du rôle pour idrole: ${idRole}`);
    console.log('Liste des rôles disponibles:', roles);
    
    if (!idRole) {
      console.warn('idrole est undefined ou null');
      return null;
    }

    const role = roles.find(r => {
      console.log(`Comparaison: ${r.id} (${typeof r.id}) === ${idRole} (${typeof idRole})`);
      return r.id === Number(idRole);
    });

    if (role) {
      console.log(`Rôle trouvé: ${role.role} pour idrole: ${idRole}`);
    } else {
      console.warn(`Aucun rôle trouvé pour idrole: ${idRole}`);
      console.log('Rôles disponibles:', roles.map(r => `${r.id}:${r.role}`));
    }

    return role ? role.role : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    console.log('Début du processus de connexion...');
    console.log('Données saisies:', { password: '***', position });

    if (!password.trim()) {
      console.warn('Mot de passe vide');
      setError('Veuillez entrer votre mot de passe.');
      setIsLoading(false);
      return;
    }

    if (position === 'Select Position') {
      console.warn('Poste non sélectionné');
      setError('Veuillez sélectionner votre poste');
      setIsLoading(false);
      return;
    }

    try {
      console.log('Authentification en cours...');
      const result = await api.getOperatorByPassword(password);
      console.log('Réponse API getOperatorByPassword:', result);
      
      let userData = Array.isArray(result) ? result[0] : result;
      console.log('Données utilisateur extraites:', userData);

      if (userData && (userData.uniqueIdentifier === password || userData.id)) {
        console.log('Utilisateur authentifié avec succès');
        console.log('Détails utilisateur:', {
          id: userData.id,
          uniqueIdentifier: userData.uniqueIdentifier,
          idRole: userData.idRole,
          name: userData.name,
          username: userData.username
        });

        if (position === "Quality Control") {
          console.log('Vérification des autorisations pour Quality Control...');
          console.log(`idrole de l'utilisateur: ${userData.idRole}`);
          
          const userRole = getRoleNameById(userData.idRole);
          console.log(`Rôle déterminé: ${userRole}`);
          
          if (userRole !== "quality") {
            console.warn(`Accès refusé - Rôle actuel: "${userRole}", Rôle requis: "quality"`);
            setError("Cet opérateur n'a pas l'autorisation d'accéder à l'interface Quality Control");
            setPassword('');
            setIsLoading(false);
            return;
          }
          
          console.log('Autorisation Quality Control accordée');
        }

        const userRoleName = getRoleNameById(userData.idRole);
        console.log(`Préparation des données de session - Rôle: ${userRoleName}`);
        
        const loginData = {
          user: userData.uniqueIdentifier || userData.username || password,
          id: userData.id,
          name: userData.name || userData.username || 'Operator',
          position,
          role: userRoleName,
          idRole: userData.idRole
        };

        console.log(' Données de connexion envoyées:', loginData);
        onLogin(loginData);
        console.log('Connexion réussie!');
        
      } else {
        console.warn('Échec authentification - Données utilisateur invalides');
        setError('Mot de passe incorrect ou utilisateur introuvable');
        setPassword('');
      }
    } catch (err) {
      console.error('Erreur lors de la connexion:', err);
      console.error('Détails techniques:', {
        message: err.message,
        stack: err.stack,
        name: err.name
      });
      
      if (err.message.includes('404') || err.message.includes('Not Found')) {
        console.warn('Utilisateur non trouvé (404)');
        setError('Utilisateur introuvable. Veuillez vérifier votre mot de passe.');
      } else if (err.message.includes('Network') || err.message.includes('Failed to fetch')) {
        console.error('Erreur réseau');
        setError('Erreur serveur. Veuillez vérifier votre connexion.');
      } else {
        console.error('Erreur inconnue');
        setError('Échec de la connexion. Veuillez réessayer.');
      }
      setPassword('');
    } finally {
      console.log('Fin du processus de connexion');
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Interface de connexion</h1>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">Mot de passe:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              placeholder="Entrez votre mot de passe"
              disabled={isLoading}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">Poste:</label>
            <select
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              className="form-select"
              disabled={isLoading}
            >
              <option value="Select Position" disabled>Sélectionnez le poste</option>
              {AVAILABLE_POSITIONS.map(pos => (
                <option key={pos} value={pos}>{pos}</option>
              ))}
            </select>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            className={`submit-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Chargement...
              </>
            ) : (
              'Valider'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;